var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg18LaptopStand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.405 533.546L879.708 552.073C879.151 552.374 879.147 553.171 879.701 553.477L894.18 561.473C897.957 563.559 902.53 563.601 906.344 561.587L939.801 548.744V549.544L908.585 565.831C903.34 568.601 897.053 568.542 891.86 565.675L877.381 557.679C873.503 555.537 873.53 549.952 877.43 547.849L913.405 532.746V533.546Z",
    fill: "#9CA6AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.005 533.146L879.708 551.273C879.151 551.574 879.147 552.371 879.701 552.677L894.18 560.673C897.957 562.759 902.53 562.802 906.344 560.787L932.602 547.944L939.801 548.744L908.585 565.031C903.34 567.801 897.053 567.742 891.86 564.875L877.381 556.879C873.503 554.737 873.53 549.152 877.43 547.049L906.344 532.346L913.005 533.146Z",
    fill: "url(#paint0_linear_2079_1030)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M911.804 512.349V533.346L906.205 532.346L906.605 509.149L911.804 512.349Z",
    fill: "url(#paint1_linear_2079_1030)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M906.665 508.939C906.781 508.751 907.027 508.693 907.215 508.808L912.605 512.125L913.405 532.953L911.805 533.753V512.572L906.796 509.49C906.608 509.374 906.549 509.128 906.665 508.939Z",
    fill: "url(#paint2_linear_2079_1030)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M938.201 527.547V548.744L932.602 547.944L933.002 524.347L938.201 527.547Z",
    fill: "url(#paint3_linear_2079_1030)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M938.202 527.547L901.806 547.944L896.207 544.345L933.002 524.347L938.202 527.547Z",
    fill: "url(#paint4_linear_2079_1030)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M911.804 512.349L875.408 532.746L869.809 529.147L906.605 509.149L911.804 512.349Z",
    fill: "url(#paint5_linear_2079_1030)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M911.805 512.348L911.805 518.748C911.033 515.541 909.415 513.973 906.605 515.148L911.805 512.348Z",
    fill: "#61676A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M938.202 527.547L938.202 533.946C937.43 530.74 935.812 529.171 933.002 530.347L938.202 527.547Z",
    fill: "#61676A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M896.403 538.281L901.798 541.316C902.05 541.457 902.206 541.724 902.206 542.013V547.66C902.206 547.966 901.876 548.159 901.61 548.009L896.214 544.974C895.963 544.832 895.807 544.566 895.807 544.277V538.629C895.807 538.324 896.136 538.131 896.403 538.281Z",
    fill: "url(#paint6_linear_2079_1030)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M870.006 523.083L875.401 526.118C875.653 526.259 875.809 526.526 875.809 526.815V532.462C875.809 532.768 875.479 532.961 875.213 532.811L869.817 529.776C869.566 529.634 869.41 529.368 869.41 529.079V523.431C869.41 523.125 869.739 522.933 870.006 523.083Z",
    fill: "url(#paint7_linear_2079_1030)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M902.206 547.944V541.945C903.006 545.145 904.606 545.945 907.405 544.745L902.206 547.944Z",
    fill: "#61676A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M875.809 532.746V526.747C876.609 529.946 878.209 530.746 881.008 529.546L875.809 532.746Z",
    fill: "#61676A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M911.753 512.553C911.861 512.745 911.793 512.989 911.6 513.097L876.005 533.095C875.812 533.203 875.568 533.135 875.46 532.942C875.352 532.75 875.42 532.506 875.613 532.398L911.209 512.4C911.401 512.292 911.645 512.36 911.753 512.553Z",
    fill: "#737E87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M938.15 527.751C938.258 527.943 938.19 528.187 937.997 528.295L902.402 548.293C902.209 548.401 901.965 548.333 901.857 548.14C901.749 547.948 901.817 547.704 902.01 547.596L937.606 527.598C937.798 527.49 938.042 527.558 938.15 527.751Z",
    fill: "#737E87"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M933.062 524.138C933.178 523.95 933.424 523.891 933.612 524.007L939.002 527.323L939.802 548.744L938.202 549.544V527.77L933.193 524.688C933.005 524.572 932.946 524.326 933.062 524.138Z",
    fill: "url(#paint8_linear_2079_1030)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2079_1030",
    x1: 915.404,
    y1: 539.146,
    x2: 885.408,
    y2: 561.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33393C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E6468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2079_1030",
    x1: 909.405,
    y1: 511.949,
    x2: 909.405,
    y2: 533.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42474A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2079_1030",
    x1: 907.405,
    y1: 508.749,
    x2: 910.005,
    y2: 533.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929EA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48555F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2079_1030",
    x1: 935.802,
    y1: 527.147,
    x2: 935.802,
    y2: 548.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42474A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2079_1030",
    x1: 933.002,
    y1: 524.347,
    x2: 900.206,
    y2: 543.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55595C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2079_1030",
    x1: 906.605,
    y1: 509.149,
    x2: 873.809,
    y2: 528.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55595C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2079_1030",
    x1: 899.006,
    y1: 537.946,
    x2: 899.006,
    y2: 548.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2079_1030",
    x1: 872.609,
    y1: 522.747,
    x2: 872.609,
    y2: 533.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2079_1030",
    x1: 933.802,
    y1: 523.947,
    x2: 936.402,
    y2: 548.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929EA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48555F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg18LaptopStand);
export default __webpack_public_path__ + "static/media/18LaptopStand.e2c6fbb61a54d051f0c0011d435d464b.svg";
export { ForwardRef as ReactComponent };